export default __webpack_public_path__ + "static/media/f12.5819e6a6.jpg";